import {
  appRoutes,
  commonButtonMessages,
  insertDataUserRegistrationMessages,
  PersonaTipoUtenteEnum,
  resetUserRegistrationState,
  useInsertDataPageLogic
} from 'azshared';
import React, { FormEvent, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { AppButton, AppButtonType } from '../../../../components/buttons/app-button';
import { Card } from '../../../../components/card/card';
import { AppInputText } from '../../../../components/input-text/app-input-text';
import { AppLink } from '../../../../components/labels/app-link';
import { AppRequiredNote } from '../../../../components/required-note/required-note';
import { useGlobalActions, useGoToLoginFromRegistration } from '../../../../hooks/global-actions';
import { LoginContainer } from '../../login-container/login-container';
import './insert-data-user-registration-page.scss';
import { BannerCookiePolicy } from 'src/components/banner-cookie-policy/banner-cookie-policy';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

export const InsertDataUserRegistrationPage = () => {
  const { formatMessage } = useIntl();
  const goToLoginFromRegistration = useGoToLoginFromRegistration();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    buttonDisabled,
    selectedOptionUserType,
    userCode,
    userCodeUnchanged,
    fiscalCode,
    vatCodeFiscalCode,
    fiduciaria,
    setupAccountRequestStatus,
    getStatusRegistrazioneRequestStatus,
    handleSubmit,
    updateUserCode,
    updateFiscalCode,
    updateVatCodeFiscalCode
  } = useInsertDataPageLogic(useGlobalActions());

  const handleLoginLinkClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      goToLoginFromRegistration();
    },
    [goToLoginFromRegistration]
  );

  const onSubmit = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      handleSubmit();
    },
    [handleSubmit]
  );

  const handleClickGoBack = useCallback(() => {
    dispatch(resetUserRegistrationState());
    navigate(appRoutes.UserRegistration);
  }, [dispatch, navigate]);

  return (
    <>
      <LoginContainer>
        <div className='insert-data-user-registration-page'>
          <Card
            title={formatMessage(insertDataUserRegistrationMessages.pageTitle)}
            subtitle={formatMessage(insertDataUserRegistrationMessages.pageSubtitle)}
            back={formatMessage(commonButtonMessages.backLink)}
            clickGoBack={handleClickGoBack}>
            <form onSubmit={onSubmit}>
              <div>
                <AppInputText
                  placeholder={formatMessage(insertDataUserRegistrationMessages.placeholderUserCodeInputText)}
                  label={formatMessage(insertDataUserRegistrationMessages.labelUserCodeInputText)}
                  required
                  value={userCodeUnchanged ? userCodeUnchanged : userCode}
                  onChange={updateUserCode}
                />
                {selectedOptionUserType === PersonaTipoUtenteEnum.Pf && (
                  <AppInputText
                    placeholder={formatMessage(insertDataUserRegistrationMessages.placeholderFiscalCodeInputText)}
                    label={formatMessage(insertDataUserRegistrationMessages.labelFiscalCodeInputText)}
                    required
                    value={fiscalCode}
                    onChange={updateFiscalCode}
                  />
                )}

                {selectedOptionUserType === PersonaTipoUtenteEnum.Pg && (
                  <AppInputText
                    placeholder={formatMessage(
                      fiduciaria
                        ? insertDataUserRegistrationMessages.placeholderOnlyVatCodeInputText
                        : insertDataUserRegistrationMessages.placeholderVatCodeInputText
                    )}
                    label={formatMessage(
                      fiduciaria ? insertDataUserRegistrationMessages.labelOnlyVatCodeInputText : insertDataUserRegistrationMessages.labelVatCodeInputText
                    )}
                    required
                    value={vatCodeFiscalCode}
                    onChange={updateVatCodeFiscalCode}
                  />
                )}
              </div>
              <AppRequiredNote />
              <div className='button'>
                <AppButton
                  type={AppButtonType.SUBMIT}
                  label={formatMessage(insertDataUserRegistrationMessages.buttonInserDataUserRegistration)}
                  disabled={buttonDisabled}
                  loading={[setupAccountRequestStatus, getStatusRegistrazioneRequestStatus].includes('loading')}
                />
              </div>
            </form>
            <span className='disclaimer'>
              {formatMessage(commonButtonMessages.linkBackToLogin)}{' '}
              <AppLink to={appRoutes.Login} replace={true} label={formatMessage(commonButtonMessages.linkToLogin)} onClick={handleLoginLinkClick} />
            </span>
          </Card>
        </div>
      </LoginContainer>
      <BannerCookiePolicy />
    </>
  );
};
